import React, { useEffect, useState } from 'react';
import { texts } from '../../../general/texts';
import { Button, Grid, Divider, Typography, List, ListItem } from '@mui/material';
import { ReactComponent as IconClose } from '../../../../icons/closeButton.svg';
import colors from '../../../colors';
import { makeStyles } from '@mui/styles';
import DevicesIcon from '@mui/icons-material/Devices';
import { useDispatch, useSelector } from 'react-redux';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { sendGeneralRequest } from '../../../../features/generalRequest';

export const LoggedDevices = ({ onBackButtonClick }) => {

    const dispatch = useDispatch()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const [registeredDevices, setRegisteredDevices] = useState([])
    const [loggedDevices, setLoggedDevices] = useState([])

    useEffect(() => {
        dispatch(sendGeneralRequest({ request: { _request: { token: globalDataSliceState.token, comeFromLogin: false, type: 1 } }, baseUrlKey: 'auth', endpoint: 'GetRegisteredDevice' })).then((response) => {
            if (response.payload?.response?.success) {
                const devices = response.payload.response.registeredDevice || []
                 setLoggedDevices(devices.filter(device => device.type === "LOGGED-IN"));
                 setRegisteredDevices(devices.filter(device => device.type === "REGISTERED"));
            }
        })
    }, [globalDataSliceState.token]);

    const useStyles = makeStyles({
        scrollBar: {
            "&::-webkit-scrollbar": {
                width: "5px",
                height: "50%",
            },
            "&::-webkit-scrollbar-track": {
                backgroundColor: '#FFFFFF',
                borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
                background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
                borderRadius: "10px",
                maxHeight: '50%'
            },
            "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
            }
        },
        listContainer: {
            overflow: 'auto',
            maxHeight: '40vh',
            '@media (max-width: 899px)': { maxHeight: '30vh' }
        },
    })
    const classes = useStyles();

    return (
        <>
            <Grid container justifyContent='center'>
                <Grid container item md={6} xs={10} mt={1} mb={2} justifyContent={'right'} marginRight={-40} sx={{ '@media (max-width: 899px)': { marginRight: '0' } }}>
                    <Button sx={{ borderRadius: '20px', ":hover": { backgroundColor: colors.lightOrange } }} onClick={onBackButtonClick}><IconClose /></Button>
                </Grid>
                <Grid item md={12} xs={12} marginBottom={2}>
                    <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '1.3rem' }} >{texts["logged-devices"]}</Typography>
                </Grid>
                <Grid container item md={12} xs={12} mt={1} spacing={2}>
                    <Grid item md={5} xs={12} marginLeft={10} justifyContent='center' sx={{ '@media (max-width: 899px)': { marginLeft: '2%' } }}>
                        <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '1rem', marginBottom: '20px' }}>{texts["saved-devices"]}</Typography>
                        <List className={classes.listContainer + " " + classes.scrollBar}>
                            {registeredDevices.length > 0 && registeredDevices.map((device, index) => (
                                <ListItem key={index}>
                                    <Grid container item md={12} xs={12} flexDirection='row' spacing={1.5}>
                                        <Grid container flexDirection={'column'} justifyContent={'center'} item xs={3} md={2}>
                                            <img width={'40vw'} src={device?.deviceLogo}/>
                                            {/* <DevicesIcon color='warning' /> */}
                                        </Grid>
                                        <Grid container item md={10} xs={9} spacing={1} sx={{ '@media (max-width: 1220px)': { pl: '20%' } }} >
                                            <Grid container item justifyContent={'flex-start'} md={12}>
                                                <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue }}>{device?.devicePlatform}</Typography>
                                            </Grid>
                                            <Typography sx={{ fontFamily: 'GerberaLight', color: colors.darkBlue, fontSize: '0.8rem', marginLeft: '10px' }}>{device?.createdAt}</Typography>
                                        </Grid>
                                        <Divider sx={{ width: '80%', ml: '12%', mt: '10px' }} />
                                    </Grid>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>

                    <Grid item md={5} xs={12} marginLeft={1}>
                        <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '1rem', marginBottom: '20px' }}>{texts["title-history"]}</Typography>
                        <List className={classes.listContainer + " " + classes.scrollBar}>
                            {loggedDevices.length > 0 && loggedDevices.map((device, index) => (
                                <ListItem key={index}>
                                    <Grid container item md={12} xs={12} flexDirection='row' spacing={1.5}>
                                        <Grid container flexDirection={'column'} justifyContent={'center'} item xs={3} md={2}>
                                            <img width={'40vw'} src={device?.deviceLogo}/>
                                            {/* <DevicesIcon color='warning' /> */}
                                        </Grid>
                                        <Grid container item md={10} xs={9} spacing={1} sx={{ '@media (max-width: 1220px)': { pl: '20%' } }} >
                                            <Grid container item justifyContent={'flex-start'} md={12}>
                                                <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue }}>{device?.devicePlatform}</Typography>
                                            </Grid>
                                            <Typography sx={{ fontFamily: 'GerberaLight', color: colors.darkBlue, fontSize: '0.8rem', marginLeft: '10px' }}>{device?.createdAt}</Typography>
                                        </Grid>
                                        <Divider sx={{ width: '80%', ml: '12%', mt: '10px' }} />
                                    </Grid>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Grid>
        </>

    )
}

export default LoggedDevices